import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export const verveCoffeeSalesOrderShippingLabelFileDataSchema = yup.object().shape({
  outShipmentId: yup.string().nullable().optional(),
  salesOrderId: yup.string().nullable().optional(),
  headerTitle: yup.string().nullable().optional(),
  shipDate: yup.string().nullable().optional(),
  shipToName: yup.string().nullable().optional(),
  shipToAddressLine1: yup.string().nullable().optional(),
  shipToAddressLine2: yup.string().nullable().optional(),
  barcode: yup.string().nullable().optional(),
  barcodeText: yup.string().nullable().optional(),
})

export type VerveCoffeeSalesOrderShippingLabelFileData = yup.InferType<
  typeof verveCoffeeSalesOrderShippingLabelFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<VerveCoffeeSalesOrderShippingLabelFileData>

export const verveCoffeeSalesOrderShippingLabelFileMappings: RequiredFileData = {
  outShipmentId: '853cf06a-a554-4aa1-a698-1e7a6d4b1c32',
  salesOrderId: '291ff787-cdf3-48f8-bcb9-a777b515636e',
  headerTitle: '2ea8f1e9-da64-4695-8247-ea86b16f0313',
  shipDate: 'dc8293c1-01c9-40da-ae77-b19614585c2a',
  shipToName: '54d034f8-5e90-4836-89d9-a108b3dc2c4c',
  shipToAddressLine1: '08b52aac-0543-4723-ae58-e5052906cfb4',
  shipToAddressLine2: '8b57fbbb-0d12-41d8-9106-1fd90957c927',
  barcode: '1913fc21-f666-4d38-9580-612dc8fb3855',
  barcodeText: 'a79b7501-41d0-4bb4-a0ad-5ad22ff73559',
}
